// extracted by mini-css-extract-plugin
export var chatHtmlText = "_uj-2";
export var chatLink = "_uj-0";
export var chatText = "_uj-1";